export default {
  baseStyle: {
    fontFamily: 'Open Sans',
    transition: 'all ease .3s'
  }
}
